export enum UserRole {
    ADMIN = 'ADMIN',
    RESELLER = 'RESELLER',
    LEARNER = 'LEARNER'
}
